import AppointmentForm from "components/Forms/AppointmentForm"
import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { Button, Card, CardBody, Modal, Row } from "reactstrap"
import ReactBSAlert from "react-bootstrap-sweetalert"
import api from "services/api"
import { hoursToMinutes } from "utils/timeHandling"
import ConfirmationModal from "../ConfirmationModal"

const emptyAppointment = {
  activity: "",
  description: "",
  date: "",
  hours: "00:00",
}

function Appointment(props) {
  const [appointmentBody, setAppointmentBody] = useState(emptyAppointment)

  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false)
  const [confirmationModalAction, setConfirmationModalAction] = useState({})

  const [blockSave, setBlockSave] = useState(false)
  const [alert, setAlert] = useState(null)

  // Saldo disponível já somando de volta as horas originais deste apontamento,
  // para não penalizar o próprio valor que ele já ocupava antes de ser editado.
  const originalMinutes = hoursToMinutes(props.appointment?.hours || "00:00")
  const formRemainingMinutes = props.activityRemainingMinutes + originalMinutes

  const hideAlert = () => setAlert(null)

  const showAlert = (message) => {
    setAlert(
      ReactDOM.createPortal(
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Atenção!"
          onConfirm={hideAlert}
          onCancel={hideAlert}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          {message}
        </ReactBSAlert>,
        document.body
      )
    )
  }

  /**
   * closes modal
   */
  function closeModal() {
    props.closeModal()
    setAppointmentBody({
      ...props.appointment,
      date: props.appointment.date.split("T")[0],
    })
  }

  const deleteAppontment = async () => {
    try {
      await api.delete(`appointment/delete/${appointmentBody._id}`)
      props.updateActivities()
      closeModal()
    } catch (error) {
      closeModal()
    }
  }

  /**
   * saves appointment
   */
  const saveAppointment = async () => {
    const totalMinutes = hoursToMinutes(appointmentBody.hours)

    if (totalMinutes <= 0) {
      showAlert("Digite uma quantidade de horas válida")
      return
    }

    if (props.activity.hoursSettled && totalMinutes > formRemainingMinutes) {
      showAlert("Não há saldo de horas suficiente para apontar esse valor")
      return
    }

    setBlockSave(true)
    appointmentBody.osCreated = false
    appointmentBody.activity = props.activity._id

    try {
      await api.patch(`appointment/update/${appointmentBody._id}`, {
        ...appointmentBody,
        cost:
          (appointmentBody.hourlyRate * hoursToMinutes(appointmentBody.hours)) /
          60,
      })
      props.updateActivities()
      closeModal()
    } catch (error) {
      showAlert("Erro ao salvar o apontamento")
      closeModal()
    } finally {
      setBlockSave(false)
    }
  }

  /**
   * hook to mount appointment body based on property apointment
   */
  useEffect(() => {
    if (props.appointment?._id) {
      setAppointmentBody({
        ...props.appointment,
        date: props.appointment.date.split("T")[0],
      })
    }
  }, [props.appointment])

  return (
    <>
      {alert}
      <Modal
        className="modal-dialog-centered"
        size="lg"
        isOpen={props.isOpen}
        autoFocus={false}
      >
      <div className="modal-header">
        <h5 className="modal-title">{props.title}</h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={(e) => closeModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            <Card>
              <CardBody>
                <AppointmentForm
                  activity={props.activity}
                  readOnly={appointmentBody.osCreated || props.schedule.status === "PA"}
                  appointmentBody={appointmentBody}
                  activityRemainingMinutes={formRemainingMinutes}
                  showAlert={showAlert}
                  setAppointmentBody={(prop) => {
                    setAppointmentBody((prev) => ({ ...prev, ...prop }))
                  }}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </Row>
      <div className="modal-footer">
        {!appointmentBody.osCreated && props.schedule.status !== "PA" && (
          <>
            <Button
              color="warning"
              data-dismiss="modal"
              type="button"
              disabled={appointmentBody.osCreated || props.schedule.status === "PA"}
              onClick={(e) => {
                setConfirmationModalAction({
                  action: "delete",
                  text: `Excluir apontamento?`,
                })
                setConfirmationModalOpen(true)
              }}
            >
              Excluir
            </Button>
            <Button
              disabled={appointmentBody.osCreated || props.schedule.status === "PA" || blockSave}
              color="success"
              type="button"
              onClick={(e) => saveAppointment()}
            >
              {props.action}
            </Button>
          </>
        )}
        <ConfirmationModal
          isOpen={confirmationModalOpen}
          action={confirmationModalAction}
          closeModal={() => {
            setConfirmationModalOpen(false)
          }}
          confirm={async () => {
            deleteAppontment()
            closeModal()
          }}
          deny={() => {
            setConfirmationModalOpen(false)
          }}
        />
      </div>
      </Modal>
    </>
  )
}
export default Appointment
